export type DateLike = Date | string | null | undefined;

export const formatDate = (date: DateLike): string => {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export const formatDateToYYYYMMDD = (date: DateLike): string => {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Validates if effective date is not after expiry date
 * @param effectiveDate - The effective date
 * @param expiryDate - The expiry date
 * @returns true if effective date is greater than expiry date (invalid), false otherwise
 */
export const isDateRangeInvalid = (
  effectiveDate: DateLike,
  expiryDate: DateLike
): boolean => {
  if (!effectiveDate || !expiryDate) {
    return false;
  }

  const eff = new Date(effectiveDate);
  const exp = new Date(expiryDate);

  // Return true if invalid (effective > expiry)
  return eff > exp;
};

export const exportDateformat = (date: Date): string => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};
